import React, { useState } from "react";
import "./navbar.css";

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen((prev) => !prev);
  const closeMenu = () => setIsOpen(false);

  return (
    <div>
      <header className="nav-container">
        <a href="/">
          <img
            className="logo"
            src="/static/images/logo-greyscale-interior-4u.png"
            alt="Logo-Interior-4U"
          />
        </a>

        <nav className="page-list-desktop">
          <a className="page" href="/">Home</a>
          <a className="page" href="#services">Services</a>
          {/* <a className="page" href="/projects">Projects</a> */}
          <a className="page" href="#about">About</a>
          <a className="page" href="#contact">Contact</a>
          <a className="page" href="https://www.handymaninmelbourne.au/">Handyman</a>
        </nav>

        <div className="social-list-desktop">
          <a
            className="social-icon instagram"
            href="https://www.instagram.com/interior_4u.au/"
          >
            <ion-icon name="logo-instagram"></ion-icon>
          </a>
          <a
            className="social-icon whatsapp"
            href="https://wa.me/61412279273"
          >
            <ion-icon name="logo-whatsapp"></ion-icon>
          </a>
        </div>

        <button className="hamburger" onClick={toggleMenu}>
          {isOpen ? (
            <ion-icon name="close-outline"></ion-icon>
          ) : (
            <ion-icon name="menu-outline"></ion-icon>
          )}
        </button>
      </header>

      <div className={`mobile-menu ${isOpen ? "open" : ""}`}>
        <a className="page" href="/" onClick={closeMenu}>Home</a>
        <a className="page" href="#services" onClick={closeMenu}>Services</a>
        {/* <a className="page" href="/projects">Projects</a> */}
        <a className="page" href="#about" onClick={closeMenu}>About</a>
        <a className="page" href="#contact" onClick={closeMenu}>Contact</a>
        <a
          className="page"
          href="https://handymaninmelb.com.au"
          onClick={closeMenu}
        >
          Handyman
        </a>

        <div className="social-in-menu">
          <a
            className="social-icon instagram"
            href="https://www.instagram.com/interior_4u.au/"
            target="_blank"
            rel="noreferrer"
          >
            <ion-icon name="logo-instagram"></ion-icon>
          </a>
          <a
            className="social-icon whatsapp"
            href="https://wa.me/61412279273"
            target="_blank"
            rel="noreferrer"
          >
            <ion-icon name="logo-whatsapp"></ion-icon>
          </a>
        </div>
      </div>
    </div>
  );
};

export default NavBar;